<template>
  <div class="t-card">
    <h5 class="t-card--title">{{ $t("announcement.plural") }}</h5>

    <template v-if="myOrganizationAnnouncements && myOrganizationAnnouncements.docs.length">
      <div v-for="item in myOrganizationAnnouncements.docs" :key="item._id">
        <notify-card :announcement="item" v-b-modal="'my-announcement-' + item._id" style="font-size: 14px;" />
        <modal :id="'my-announcement-' + item._id" :title="$t('announcement.detail')">
          <announcement-detail :announcement="item" />
        </modal>
      </div>

      <div class="d-flex mt-auto justify-content-center">
        <b-pagination
          v-model="organizationRequest.options.page"
          :total-rows="myOrganizationAnnouncements.totalDocs"
          :per-page="myOrganizationAnnouncements.limit"
          limit="10"
          class="mt-4"
        >
          <template #page="{ page, active }">
            <b v-if="active">{{ page }}</b>
            <i v-else>{{ page }}</i>
          </template>
        </b-pagination>
      </div>
    </template>
    <div v-else>
      <empty width="100px">
        <h5 class="text-center">
          {{ $t("announcement.no") }}
        </h5>
      </empty>
    </div>
  </div>
</template>

<script>
import AnnouncementDetail from "@modules/announcement/announcement-detail";
import NotifyCard from "./notify-card.vue";

import Modal from "@c/modal.vue";

const state = "announcement";
export default {
  components: {
    NotifyCard,
    Modal,
    AnnouncementDetail,
  },
  data() {
    return {
      systemRequest: {
        options: { page: 1, limit: 5 },
        query: {},
      },

      organizationRequest: {
        options: { page: 1, limit: 5 },
        query: {},
      },
      selectedAnnouncement: undefined,
    };
  },
  watch: {
    systemRequest: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },
    organizationRequest: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },
  },
  computed: {
    myOrganizationAnnouncements() {
      return this.$store.getters[`organizationAnnouncement/myOrganizationAnnouncements`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
  },
  mounted() {},
  methods: {
    init() {
      this.$store.dispatch(`organizationAnnouncement/fetchUserAccessableAnnouncements`, this.organizationRequest);
      this.selectedItems = [];
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
  },
};
</script>

<style></style>
